import { render, staticRenderFns } from "./TemperatureIndicator.vue?vue&type=template&id=2ff3c264&scoped=true"
import script from "./TemperatureIndicator.vue?vue&type=script&lang=js"
export * from "./TemperatureIndicator.vue?vue&type=script&lang=js"
import style0 from "./TemperatureIndicator.vue?vue&type=style&index=0&id=2ff3c264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3c264",
  null
  
)

export default component.exports